'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'tire-rugged';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f634';
var svgPathData = ['M128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm82.3-14.8a24 24 0 1 1 -45.7-14.8 24 24 0 1 1 45.7 14.8zm22.7 87.2a24 24 0 1 1 -38.8-28.2 24 24 0 1 1 38.8 28.2zM280 184a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm37.7 116.1a24 24 0 1 1 -38.8 28.2 24 24 0 1 1 38.8-28.2zm29.6-73.8a24 24 0 1 1 -45.7 14.8 24 24 0 1 1 45.7-14.8z', 'M296 0c13.3 0 24 10.7 24 24l0 16c0 .4 0 .8 0 1.3c14.9 4.4 29.2 10.4 42.6 17.7c.3-.3 .6-.6 .9-.9l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9L454 148.5c-.3 .3-.6 .6-.9 .9c7.3 13.4 13.2 27.7 17.7 42.6c.4 0 .8 0 1.3 0l16 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-16 0c-.4 0-.8 0-1.3 0c-4.4 14.9-10.4 29.2-17.7 42.6c.3 .3 .6 .6 .9 .9l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0L363.5 454c-.3-.3-.6-.6-.9-.9c-13.4 7.3-27.7 13.2-42.6 17.7c0 .4 0 .8 0 1.3l0 16c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-16c0-.4 0-.8 0-1.3c-14.9-4.4-29.2-10.4-42.6-17.7c-.3 .3-.6 .6-.9 .9l-11.3 11.3c-9.4 9.4-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9L58 363.5c.3-.3 .6-.6 .9-.9c-7.3-13.4-13.2-27.7-17.7-42.6c-.4 0-.8 0-1.3 0l-16 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24l16 0c.4 0 .8 0 1.3 0c4.4-14.9 10.4-29.2 17.7-42.6c-.3-.3-.6-.6-.9-.9L46.7 137.2c-9.4-9.4-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0L148.5 58c.3 .3 .6 .6 .9 .9c13.4-7.3 27.7-13.2 42.6-17.7c0-.4 0-.8 0-1.3l0-16c0-13.3 10.7-24 24-24l80 0zm88 256a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTireRugged = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;